export const CALENDAR_PAGE_SIZE = 500;
/** Safety cap; multi-month admin views can expand one VQA into many rows per page. */
export const CALENDAR_MAX_PAGES = 25;

export async function fetchCalendarPages(fetchPage, { startPage = 1, maxPages = CALENDAR_MAX_PAGES } = {}) {
  const first = await fetchPage(startPage);
  const totalPages = Number(first?.total_pages) || startPage;
  const lastPage = Math.min(totalPages, startPage + maxPages - 1);
  const remainingPages = Array.from({ length: Math.max(lastPage - startPage, 0) }, (_, i) => startPage + 1 + i);
  const rest = await Promise.all(remainingPages.map((page) => fetchPage(page)));
  const items = [first, ...rest].flatMap((response) => response?.items || []);

  const totalItems = Number(first?.total_items) || items.length;
  return { ...first, items, total_items: totalItems, is_truncated: items.length < totalItems };
}

export function getCalendarTruncationMessage(data) {
  if (!data?.is_truncated) return null;
  return `Showing ${data.items.length} of ${data.total_items} scheduled assessments. Narrow the filters or the date range to see the rest.`;
}
